
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/1106b525b6d02d4bd279b8a130c49798.jpg"
          alt="Technology Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-[5%] text-center text-white">
        <div className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6 border border-white/20">
          <span className="text-sm font-medium">Automation Consulting Excellence Since 2022</span>
        </div>
        
        <h1 className="text-7xl font-bold mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          {t('hero.subtitle')}
        </h1>
        
        <p className="text-xl mb-10 text-gray-100 max-w-3xl mx-auto leading-relaxed">
          {t('hero.description')}
        </p>
        
        <div className="flex items-center gap-5 justify-center">
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-white text-gray-900 rounded-lg font-semibold text-sm hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('nav.contact')}
          </button>
        </div>
      </div>
    </section>
  );
}
